import React from "react";
import WithRoutify from "../../../hoc/WithRoutify";
import VisitHistory from "./VisitHistory";
import WorkCompList from "./WorkCompList";
import PhysicalsList from "./PhysicalsList";
import Buttons from "../../../components/UI/Buttons";
import OtherTab from "./OtherTab";
import FullScreenMode from "../../../components/UI/FullScreenMode";
import ImagesList from "./Images";
import ScreeningsList from "./ScreeningsList";
import { decryptString } from "../../../utils/commonUtils";
import LabsHistoryList from "./LabsHistoryList";
import VaccinesHistoryList from "./VaccinesHistoryList";
import PrescriptionsHistoryList from "./PrescriptionsHistoryList";
import WorkStatusHistoryList from "./WorkStatusHistoryList";
import SectionLoader from "../../../components/UI/SectionLoader";
import DrugScreensList from "./DrugScreensList";
import IncidentList from "./IncidentsList";
import Icons from "../../../components/UI/Icons";

class RightContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading:false,
      tableHeaders: [
        { label: "All Visits",id:'VisitHistory',component:VisitHistory, iconType:"PatientVisit" },
        { label: "Work Comp",id:'workCompList',component:WorkCompList, iconType: "WorkComp"},
        { label: "Physicals",id:'PhysicalsList',component:PhysicalsList, iconType: "Physicals" },
        { label: "All Screenings",id:'ScreeningsList',component:ScreeningsList, iconType: "Screening" },
        { label: "Drug Screens",id:'DrugscreenList',component:DrugScreensList, iconType: "DrugScreens" },
        { label: "Laboratory" ,id:'LabsList', component:LabsHistoryList, iconType: "Laboratory" },
        { label: "Vaccines" ,id:'VaccinesList',component:VaccinesHistoryList, iconType: "Vaccines" },
        { label: "RXNT Prescriptions", id: 'PrescriptionsList', component: PrescriptionsHistoryList, iconType: "Results" },
        { label: "Work Status",id:'WorkStatusList',component:WorkStatusHistoryList, iconType: "WorkStatus" },
        { label: "Referral / Auth",id:'ReferralList',component:OtherTab, iconType: "Referral" },
        { label: "Incidents",id:'IncidentsList',component:IncidentList, iconType: "Incident" },
        { label: "Images",id:'ImagesList',component:ImagesList, iconType: "Images" },
        { label: "Forms",id:'FormsList',component:OtherTab, iconType: "Forms" },
        { label: "Notes",id:'NotesList',component:OtherTab, iconType: "Notes" },
      ],
      selectedTab: 0, // Initial selected tab
      scrollerRef: React.createRef(),
      inactiveLeft:true,
    };
  }
  componentDidMount() {
    const { scrollerRef } = this.state; // Access scrollerRef from state

    const checkScroller = () => {
      if (scrollerRef.current) {
        this.setState({ inactiveLeft: scrollerRef.current.scrollLeft === 0 });
      }
    };

    const handleScroll = () => {
      if (scrollerRef.current) {
        this.setState({ inactiveLeft: scrollerRef.current.scrollLeft === 0 });
      }
    };

    checkScroller(); // Run on mount to check if already scrolled to left
    if (scrollerRef.current) {
      scrollerRef.current.addEventListener("scroll", handleScroll);
    }
  }

  componentWillUnmount() {
    const { scrollerRef } = this.state;

    if (scrollerRef.current) {
      scrollerRef.current.removeEventListener("scroll", this.handleScroll);
    }
  }

  handleTabClick = (label) => {
    this.setState({ selectedTab: label });
  };

  render() {
    const { tableHeaders, selectedTab,isLoading,scrollerRef,inactiveLeft} = this.state;
    const { params } = this.props;
    const patientDetails = decryptString(params.patientDetails);
    const ActiveComponent = tableHeaders[selectedTab].component;
    const handleRightClick = () => {
      scrollerRef.current.scrollBy({
        left: 200,
        behavior: "smooth"
      });
    };
    const handleLeftClick = () => {
      scrollerRef.current.scrollBy({
        left: -200,
        behavior: "smooth"
      });
    }
    return (
      <>
       <div className="sh_innerPortview w-100 d-flex">
        <div className="w-100">
          <div className="sh_cardBox">
            <div className="sh_cardHeader">
            <div className="form-group mb-0">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="text-lg f-500 mb-0">
                      <Buttons
                        className="badge back_btn mr-2"
                        label="Back"
                        iconType="Back"
                        acl="any"
                        href="/employee"
                      />
                    </h6>
            </div>
            </div>
            </div>
            <div className="sh_cardHeader bg-white" style={{ position: "relative", padding: "6px" }}>
              <div className="form-group mb-0">
                    <FullScreenMode />
                  </div> 
                  <div className="tabs-wrapper w-100">
                          <ul className="nav sh_employernav border-0" ref={scrollerRef} style={{ display: 'flex', width: '100%', flexWrap: 'wrap', justifyContent: 'flex-start', gap: '0' }}>
                            {tableHeaders.map((tab, index) => (
                              <li key={tab.id} >
                                <a
                                  href="#!"
                                  className={`nav-link ${
                                    selectedTab === index ? "active" : ""
                                  }`}
                                  onClick={() => this.handleTabClick(index)}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexDirection: 'row',
                                    // gap: '6px',
                                    whiteSpace: 'nowrap',
                                    padding: '8px 16px'
                                  }}
                                >
                                  {tab.iconType && (
                                    <span className="nav-icon">
                                      <Icons type={tab.iconType} />
                                    </span>
                                  )}
                                  <span>{tab.label}</span>
                                </a>
                              </li>
                            ))}
                          </ul>
                  </div>

                </div>
 
            <div
              className="sh_cardBody p-0 bg-white"
              // style={{ background: "#eef2f8", position: "relative" }}
            >
              <div
                className="card border-0 mb-0 bg-transparent"
                style={{
                  // position: "absolute",
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  zIndex: 0,
                }}
              >
                  <SectionLoader isLoading={isLoading} />
                <div className="card-body tab-content p-0 ced">
                  <ActiveComponent
                  selectedTab={tableHeaders[selectedTab].label}
                  setLoader={(bool)=>this.setState({isLoading:bool})}
                  patientDetails={patientDetails}/>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </>
    );
  }
}
 
export default WithRoutify(RightContent);
 